export class IdPUserRole {
	id: number;
	idpId: number;
	userId: string;
	orgAcctNumber: number;
	serviceId: string;
	roles: string;
	updatedAt: Date;
	organizationName: string;

	constructor(){
		this.id = 0;
		this.idpId = 0;
		this.userId = '';
		this.orgAcctNumber = 0;
		this.serviceId = '';
		this.roles = '';
		this.updatedAt = new Date();
		this.organizationName = '';
	}

}
